// extracted by mini-css-extract-plugin
export default {"button":"PatientCareCenterButton_button__X1Ivy"};